import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import "ag-grid-enterprise";
import { ColDef, IServerSideGetRowsParams } from "ag-grid-enterprise";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import { useContext, useEffect, useState } from "react";
import { transformationActions } from "../../service/transformation.action";
import "./../genericModels.css";

import { Card, CardContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import CustomLoader from "../../../../util/component/CustomLoader";
import EmptyState from "../../../../util/component/EmptyState";
import { setSnackbar } from "../../../../util/state/globalAction";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { ContextOperation } from "../../context/OperationContext";
import { FileTextWithIcon } from "../common/FileTextWithIcon";
import { Parser } from "../../utils";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const TransportPerKmTable = (props:any) => {
  const { tenant } = useContext(ContextOperation);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [rowLength, setRowLength] = useState<number>(0);
  const { t } = useTranslation(["operation"]);
  const [gridApi, setGridApi] = useState<any>(null);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [loading, setIsLoading] = useState<boolean>(false);;
    let supplierId = props.getIdSupplier;
  const columnDefs:ColDef[]=[
    {
      field: "kmRangeFrom",
      headerName: t(
        "transportSupplierPriceList.priceListPerKMTable.kmRangeFrom"
      ),
      flex: 1.1,
      cellRenderer(params: any) {
        return (
         
            <Box component={'span'}>{params.data.kmRangeFrom}</Box>
          
        );
      },
    },
    {
      field: "kmRangeTo",
      headerName: t("transportSupplierPriceList.priceListPerKMTable.kmRangeTo"),
      flex: 1.1,
      cellRenderer(params: any) {
        return (
          
            <Box component={'span'}>{params.data.kmRangeTo}</Box>
          
        );
      },
    },
    {
      field: "loadIndex",
      headerName: t("transportSupplierPriceList.priceListRouteTable.loadIndex"),
      flex: 0.8,
      cellRenderer(params: any) {
        return (
         
            <Box component={'span'}>{params.data.loadIndex}</Box>
          
        );
      },
    },
    {
      field: "excelFile",
      headerName: t(
        "transportSupplierPriceList.priceListRouteTable.priceListFile"
      ),
      flex: 1,
      cellRenderer(params: any) {
        return (
          <FileTextWithIcon 
          onDownloadFile={() => {downloadTemplateById(params.data.idFile)}}
          fileTextDownload={params.data.excelFile}
          fileWidth={true}>
    
       </FileTextWithIcon>
        //   <Stack
        //   height="inherit"
        //   alignItems="center"
        //   alignContent="center"
        //   direction="row"
        // >
        //   <Tooltip title={params.data.excelFile}>
        //     <Grid
        //       container
        //       spacing={0.5}
        //       columns={12}
        //       color="black"
        //       alignItems="center"
        //       onClick={() => downloadTemplateById(params.data.idFile)}
        //     >
              
        //       <Grid
        //         item
        //         xs={8}
               
        //       >
        //         <Typography
        //           maxWidth={200}
        //           noWrap
        //           sx={{
        //             overflow: "hidden",
        //             fontSize: "10px",
        //             textTransformation: "none",
        //             textOverflow: "ellipse",
        //             textDecoration: "underline",
        //           }}
        //           color="inherit"
        //         >
        //           {params.data.excelFile}
        //         </Typography>
        //       </Grid>
        //       <Grid sx={{display:'flex', alignItems:"flex-end"}}  item xs={'auto'}>
        //         <Box>
        //           <FileDownloadIcon
        //             sx={{ fontSize: "17px"}}
        //           />
        //         </Box>
        //       </Grid>
        //     </Grid>
        //   </Tooltip>
        // </Stack>
        
        );
      },
    },
    {
      field: "startValidityDatetime",
      headerName: t(
        "transportSupplierPriceList.priceListRouteTable.startValidity"
      ),
      flex: 1,
      cellRenderer(params: any) {
        return (
        
            <Box  component="span">
              {dayjs(`${params.data.startValidityDatetime}`).format(
                "DD/MM/YYYY"
              )}
            </Box>
         
        );
      },
    },
    {
      field: "endValidityDatetime",
      headerName: t(
        "transportSupplierPriceList.priceListRouteTable.endValidity"
      ),
      flex: 1,
      cellRenderer(params: any) {
        return (
         
            <Box component="span">
              {dayjs(`${params.data.endValidityDatetime}`).format("DD/MM/YYYY")}
            </Box>
         
        );
      },
    },
    {
      field: "price",
      headerName: t("transportSupplierPriceList.priceListRouteTable.price"),
      flex: 1,
      cellRenderer(params: any) {
        return (
        
            <Box component={'span'} sx={{ fontWeight: "700" }}>
              {params.data.currencyCode}
              {Parser.price(params.data.price)}
            </Box>
         
        );
      },
    },
  ];
   //const [pageSize, setPageSize] = useState<number>(10);
  // const [pageNumber, setPageNumber] = useState<number>(0);
  let pageSize = 10;
  const downloadTemplateById =(id:number) =>{
    setIsLoading(true);
    transformationActions().downloadTemplateById(tenant, id).then((response:any)=>{
      setIsLoading(false);
      const filename = response?.headers['content-disposition'].split('filename=')[1];
      var blob = new Blob([response.data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
         );
          FileSaver.saveAs(blob,filename);
    })
  }
  const getDistanceprice = (importListQueryParams: any) => {
    
    let dateTime = (!!importListQueryParams?.dateTime && dayjs(importListQueryParams?.dateTime).isValid()) ? dayjs
    (importListQueryParams?.dateTime )
    .format("YYYY-MM-DD"): null;
    let kms = !!importListQueryParams?.kms ? importListQueryParams?.kms : null
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        setIsLoading(true);

        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;
        
        transformationActions()
          .getDistancepriceQueryParams(
            props.getTenant,
            pageNumber,
            pageSize,
            supplierId,
            dateTime,
            kms
          )
          .then((response: any) => {
            params.successCallback(
              manageData(response),
              response.data.totalElements
            );
            setIsLoading(false);
            setRowLength(response.data.totalElements);
            
          })
          .catch((error) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message:(error.response.data.error),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message:(t("networkErrorMessage")),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            setIsLoading(false);
            } else {
              setIsLoading(false);
            }
            setIsLoading(false);
          });
      },
    };
  };
  function manageData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        id: element.id,
        kmRangeFrom: element.kmRangeFrom,
        kmRangeTo: element.kmRangeTo,
        loadIndex: element.loadIndex,
        excelFile: element.excelFile,
        startValidityDatetime: element.startValidityDate,
        endValidityDatetime: element.endValidityDate,
        price: element.price,
        currencyCode: element.currencyCode,
        idFile: element.idFile,
      };
      rows.push(row);
    });
    return rows;
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(getDistanceprice(!!props.dataSearchForm ? props.dataSearchForm : null));
    }
  }, [gridApi, props.refreshPage, supplierId]);
  return (
    <>
    <Box pl={2} pr={2}>

      <Box>

      { !props.hasSupplierId &&
            <Box >
              <Card>
                <CardContent >
                  
                <Stack  justifyContent = "center" height={500}>
                 
                <EmptyState title=  {t("transportSupplierPriceList.noSupplierMessage")}
                content = {t("transportSupplierPriceList.noSupplierContent")}/>
              
</Stack>
              </CardContent>
                </Card>
            </Box>
}

{props.hasSupplierId &&
  <Box>
    <AgGridOperationTable
      columnDefs={columnDefs}
      onGridReady={onGridReady}
      cacheBlockSize={pageSize}
      serverSideInfiniteScroll={true}
      rowModelType={"serverSide"}
      totalElements={rowLength}

      />

  </Box>
}
       
      </Box>
      {loading && <CustomLoader loading={loading}/>}
    </Box>
    
  </>
  )
}
